module.exports = __webpack_public_path__ + "static/img/cgzp.a2ac5fa5.png";